/* @flow */
import cx from 'classnames';
import React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import Message from 'entities/Message';
import ChatMessage from 'entities/ChatMessage';
import AnnouncementMessageItem from 'chat/components/AnnouncementMessageItem.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import UserLink from 'users/components/UserLink.jsx';
import shallowCompare from 'react-addons-shallow-compare';

import './styles/AnnouncementMessageListItem.scss';

type Props = {
  group: ?Group,
  messages: Array<Message | ChatMessage>,
  isGroupChat: ?boolean,
};

class AnnouncementMessageListItem extends React.Component {
  props: Props;

  shouldComponentUpdate(nextProps: Props) {
    return shallowCompare(this, nextProps, null);
  }

  getSender() {
    const { messages } = this.props;
    const firstMessage = messages[0];
    return firstMessage.getSender();
  }

  sentByCurrentUser() {
    return CurrentUser.getUserId() === this.getSender().id;
  }

  renderName() {
    const sender = this.getSender();
    const modal = <RelationshipModal userId={sender.id} />;

    return (
      <ModalTrigger modal={modal}>
        <UserLink
          userId={sender.id}
          neverShowStartChat={!this.props.isGroupChat}
          placement="right"
          color="inherit"
          alignment="top">
          <span className="AnnouncementMessageListItem-name">
            {sender.getName()}
          </span>
        </UserLink>
      </ModalTrigger>
    );
  }

  renderMessage(message: Message | ChatMessage, isCurrentUser: boolean, lastOfGroup: boolean) {
    const sender = this.getSender();
    return (
      <AnnouncementMessageItem
        key={message.getUuid()}
        message={message}
        group={this.props.group || message.getGroupSummary()}
        sentBySelf={isCurrentUser}
        senderColor={sender.getColor()}
        senderInitials={sender.getInitials()}
        lastOfGroup={lastOfGroup}
      />
    );
  }

  renderContent() {
    const { messages } = this.props;
    const sentByCurrentUser = this.sentByCurrentUser();
    const messageItems = messages.map(message => {
      const lastOfGroup = message === messages[messages.length - 1];
      return this.renderMessage(message, sentByCurrentUser, lastOfGroup);
    });

    if (sentByCurrentUser) {
      return (
        <div className="AnnouncementMessageListItem-content">
          {messageItems}
        </div>
      );
    }

    return (
      <div className="AnnouncementMessageListItem-messageGroup">
        <div className="AnnouncementMessageListItem-contentWrap">
          {this.renderName()}
          <span className="AnnouncementMessageListItem-content">
            {messageItems}
          </span>
        </div>
      </div>
    );
  }

  render() {
    const sentByCurrentUser = this.sentByCurrentUser();

    return (
      <li
        className={cx('AnnouncementMessageListItem', {
          'AnnouncementMessageListItem-self': sentByCurrentUser,
          'AnnouncementMessageListItem-other': !sentByCurrentUser,
        })}>
        {this.renderContent()}
      </li>
    );
  }
}

export default AnnouncementMessageListItem;



// WEBPACK FOOTER //
// ./src/chat/components/AnnouncementMessageListItem.jsx